import { patientAction } from '../../actions/constant';

const {
  PUT_TREATMENT_THERAPIST_FAILURE,
  PUT_TREATMENT_THERAPIST_SUCCESS,
  PUT_TREATMENT_THERAPIST_RESET,
} = patientAction;

const intitialstate: object = {
  isUpdated: false,
  response: null,
};

export const getTreatmentTherapistReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case PUT_TREATMENT_THERAPIST_SUCCESS: {
      return {
        ...state,
        isUpdated: true,
        response: action?.payload,
      };
    }

    case PUT_TREATMENT_THERAPIST_FAILURE:
      return {
        ...state,
        isUpdated: false,
        response: action?.payload,
      };

    case PUT_TREATMENT_THERAPIST_RESET:
      return intitialstate;

    default:
      return state;
  }
};
